import React, { useEffect } from 'react';
import { Target, Calendar, Check, Lightbulb, ArrowDown, ArrowRight } from 'lucide-react';
export function LlamadasSemanalesCursoPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-3257" data-mp="3kfa4o4rvbb9o">
      <main className="max-w-4xl mx-auto px-4 py-12 md:py-20" data-id="element-3258" data-mp="2rspev8r1j788">
        {/* HERO SECTION */}
        <section className="text-center space-y-6 mb-12 md:mb-16" data-id="element-3259" data-mp="2rqw7tscimkzp">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#7FFF00]/10 border border-[#7FFF00]/30 mb-2" data-id="element-3260" data-mp="2wsbqxev4uhfg">
            <Target className="w-8 h-8 text-[#7FFF00]" data-id="element-3261" data-mp="35k3ztl4idihx" />
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight" data-id="element-3262" data-mp="35lf4ro9owwam">
            Únete a las Llamadas Semanales con Gabriel Beltrán
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-3263" data-mp="2d2i31bvjgmgi">
            ¿Listo para construir un negocio digital que genere ingresos reales?
          </p>

          <p className="text-lg text-gray-400" data-id="element-3264" data-mp="2z8fl7xgizoed">
            Agenda tu llamada y elige el plan que mejor se adapte a ti:
          </p>
        </section>

        {/* PRICING PLANS */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16" data-id="element-3265" data-mp="2pi2ybyl8nj52">
          {/* Plan 3 Meses */}
          <div className="bg-gray-900/40 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col transition-transform hover:-translate-y-1 duration-300" data-id="element-3266" data-mp="2kj9nkdxc668l">
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-gray-800" data-id="element-3267" data-mp="2bhjvd5vmr39r">
              <div className="bg-gray-800 p-3 rounded-lg" data-id="element-3268" data-mp="26ip4dgnie8ek">
                <Calendar className="w-6 h-6 text-white" data-id="element-3269" data-mp="26k9zp8hndvdh" />
              </div>
              <div data-id="element-3270" data-mp="9pdvse7z9wbx">
                <h2 className="text-2xl font-bold text-white" data-id="element-3271" data-mp="9px3710052bp">Plan 3 Meses</h2>
                <p className="text-[#7FFF00] font-black text-xl" data-id="element-3272" data-mp="4sdojzze6nj8">$997</p>
              </div>
            </div>

            <ul className="space-y-4 flex-1" data-id="element-3273" data-mp="1z6smkt0r1c1u">
              <li className="flex items-start gap-3" data-id="element-3274" data-mp="23yan5fyv1ama">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3275" data-mp="23zu2n4cozhn0" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3276" data-mp="1pa642avwax2z">
                  Llamadas semanales en vivo con Gabriel Beltrán
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3277" data-mp="2hybmgqzh89zn">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3278" data-mp="2hyld8gscil6e" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3279" data-mp="2mw3oidtu5chk">
                  Acceso completo al curso{' '}
                  <strong className="text-white" data-id="element-3280" data-mp="27z2z4gz49tm9">Info Commerce Academy</strong>{' '}
                  (valorado en $2,000)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3281" data-mp="wk7k2twk5q56">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3282" data-mp="wjebrohyaskx" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3283" data-mp="11klfncgz37mb">
                  Aprende Print on Demand y mucho más
                </span>
              </li>
            </ul>
          </div>

          {/* Plan 6 Meses (Highlighted) */}
          <div className="bg-gray-900/60 border-2 border-[#7FFF00]/50 rounded-2xl p-6 md:p-8 flex flex-col relative shadow-[0_0_30px_rgba(127,255,0,0.1)] transition-transform hover:-translate-y-1 duration-300" data-id="element-3284" data-mp="3auukx195rhgc">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-[#7FFF00] to-[#6FEF00] text-black text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-lg" data-id="element-3285" data-mp="2x13dbyezm7n9">
              Recomendado
            </div>

            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-gray-800" data-id="element-3286" data-mp="35uoqjdbi7guk">
              <div className="bg-[#7FFF00]/10 p-3 rounded-lg" data-id="element-3287" data-mp="31143ggbg87a5">
                <Calendar className="w-6 h-6 text-[#7FFF00]" data-id="element-3288" data-mp="2dcb1o385b57m" />
              </div>
              <div data-id="element-3289" data-mp="29br2ku40hriu">
                <h2 className="text-2xl font-bold text-white" data-id="element-3290" data-mp="29camggd82pzi">Plan 6 Meses</h2>
                <p className="text-[#7FFF00] font-black text-xl" data-id="element-3291" data-mp="2m106x3u9olis">$1,997</p>
              </div>
            </div>

            <ul className="space-y-4 flex-1" data-id="element-3292" data-mp="2qz1otlfyieso">
              <li className="flex items-start gap-3" data-id="element-3293" data-mp="2r033s103flfo">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3294" data-mp="2vymmlsje4h3t" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3295" data-mp="30pct593jyq03">
                  Llamadas semanales en vivo con Gabriel Beltrán
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3296" data-mp="35qsfr5ldp4kl">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3297" data-mp="39pjc3ai0si6n" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3298" data-mp="3epnn4l05skph">
                  Acceso completo al curso{' '}
                  <strong className="text-white" data-id="element-3299" data-mp="3joqrs4c88owx">Info Commerce Academy</strong>{' '}
                  (valorado en $2,000)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3300" data-mp="1kdpofczh777u">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3301" data-mp="1pb90q7cm59x5" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3302" data-mp="1hrggtigsdp43">
                  Aprende Print on Demand y mucho más
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3303" data-mp="1cy5dhrb6nqgx">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3304" data-mp="1826pw5xoichk" />
                <span className="text-white font-medium leading-relaxed" data-id="element-3305" data-mp="132kdtztl72ac">
                  El doble de tiempo para implementar, crecer y escalar
                </span>
              </li>
            </ul>
          </div>
        </section>

        {/* VALUE PROPOSITION */}
        <section className="bg-gray-900/50 border border-gray-800 rounded-2xl p-8 md:p-10 text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-3306" data-mp="1vove19da716m">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/10 mb-4" data-id="element-3307" data-mp="1ltbkgtm6wel1">
            <Lightbulb className="w-6 h-6 text-yellow-500" data-id="element-3308" data-mp="fdiydsmc6qvk" />
          </div>
          <p className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-3309" data-mp="acvahftemq5k">
            Todo esto por menos de lo que vale solo el curso.
          </p>
          <p className="text-lg text-gray-400" data-id="element-3310" data-mp="2yk3jghdbm8os">
            No es solo información. Es acompañamiento, estrategia y resultados.
          </p>
        </section>

        {/* CTA SECTION */}
        <section className="text-center space-y-8 max-w-2xl mx-auto mb-16" data-id="element-3311" data-mp="2okmfq5hmq4vg">
          <div className="flex flex-col items-center gap-4" data-id="element-3312" data-mp="2tj640cjp3sqz">
            <ArrowDown className="w-8 h-8 text-[#7FFF00] animate-bounce" data-id="element-3313" data-mp="2evco0qqp6o7v" />
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-3314" data-mp="2eu1hij5vb2d2">
              Agenda tu llamada ahora y empieza a jugar en otro nivel.
            </h2>
          </div>

          <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-implementacion" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-black text-lg md:text-xl rounded-xl py-5 px-8 shadow-[0_0_20px_rgba(127,255,0,0.3)] hover:shadow-[0_0_30px_rgba(127,255,0,0.5)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3315" data-mp="25vpjvx6l34b4">
            <span className="flex items-center justify-center gap-3" data-id="element-3316" data-mp="1d86fvnsenabc">
              RESERVA TU LUGAR AQUÍ
              <ArrowRight className="w-6 h-6" data-id="element-3317" data-mp="1r7o8yfcqh9qi" />
            </span>
          </a>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12" data-id="element-3318" data-mp="1m7tdrzlxdxzn">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3319" data-mp="20846772vvkmx">
          <div className="mb-6" data-id="element-3320" data-mp="206jbnhgkk1p2">
            <p className="text-[#7FFF00] font-bold text-lg md:text-xl mb-2" data-id="element-3321" data-mp="1w7kam7xykp2w">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-3322" data-mp="29xxkwgybofve">
            <p data-id="element-3323" data-mp="250nk655hghs9">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-3324" data-mp="2ju90bft7llu2">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-3325" data-mp="2ezd4s5orkgc7">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}